import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import WebApp from './WebApp.jsx';
import { initFacebookPixel } from "./utils/facebookPixel"
import { loadGtag } from './utils/gtag.js'
import nanowebConfig from '../nanoweb.config'
if (nanowebConfig.FACEBOOK_PIXEL_ID) {
	initFacebookPixel(nanowebConfig.FACEBOOK_PIXEL_ID)
}
if (nanowebConfig.GTAG_ID) {
	loadGtag(nanowebConfig.GTAG_ID)
}

createRoot(document.getElementById('web-root')).render(
	<StrictMode>
		<WebApp />
	</StrictMode>
);
